/* Opens product collapsible-tab content in a centered modal dialog.
   Long texts are cramped in the narrow product info column → open them wider.
   Delegated so it works for any number of blocks; Esc is handled natively. */
(function () {
  function closeDialog(d) {
    if (d && d.open && typeof d.close === 'function') d.close();
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tw-dialog]');
    if (trigger) {
      e.preventDefault();
      var dlg = document.getElementById(trigger.getAttribute('data-tw-dialog'));
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
      } else if (dlg) {
        dlg.setAttribute('open', '');
      }
      return;
    }
    if (e.target.closest('[data-tw-dialog-close]')) {
      closeDialog(e.target.closest('dialog'));
      return;
    }
    // Click on the backdrop: the event target is the <dialog> element itself
    // (clicks inside the content hit a child, so they don't match).
    if (e.target instanceof HTMLDialogElement) {
      closeDialog(e.target);
    }
  });
})();
